import * as React from 'react'
import './index.scss'
import {connect} from "react-redux";
import {ActionType, developerStateType, reducerStoreType} from "../../reducers/types";
import {Dispatch} from "redux";
import CustomDialog from "../../components/CustomUIComp/CustomDialog";
import PasswordModal from "./PasswordModal";
import {injectIntl, IntlShape} from 'react-intl'

interface IProps extends developerStateType {
    dispatch: Dispatch<ActionType<any>>,
    intl: IntlShape
}

interface intfProduct {
    name: string,
    link: string,
    id: string
}

const online_products :{[key: string] : intfProduct} = {
    wappay: {
        name: '网站支付',
        id: 'webpage_api',
        link: '/Online_Website/Webpage.html'
    },
    apppay: {
        name: 'APP支付',
        id: 'app_api',
        link: '/doc/zh/App/'
    }
}

const offline_products :{[key: string] : intfProduct} = {
    barcode: {
        name: '付款码支付',
        id: 'barcode_api',
        link: '/Offline/Barcode.html'
    },
    "transaction-qrCode": {
        name: '订单二维码支付',
        id: 'transqr_api',
        link: '/Offline/TransQR.html'
    },
    jspay:{
        name: 'JS API',
        id: 'jsapi_api',
        link: '/Offline/JSAPI.html'
    }
}


class Developer extends React.Component<IProps, {}> {
    _renderProducts = () => {
        let {intl} = this.props
        let offline_arr = [], online_arr = []
        let {productList}  = this.props
        for(let i in productList){
            if(offline_products[productList[i]]){
                offline_arr.push(productList[i])
            } else if(online_products[productList[i]]){
                online_arr.push(productList[i])
            }
        }
        let elems = []

        let language = (navigator.languages && navigator.languages.length > 0) ? navigator.languages[0]
            : (navigator.language || 'en');
        console.log(language)
        let short = language.substr(0, 2)
        let docLan = short === 'zh' ? 'zh' : 'en'
        let baseUrl = 'https://www.scanforpay.com/doc/' + docLan

        for(let i = 0; i < Math.max(offline_arr.length, online_arr.length); i++){
            let html = (<div className="intf table-style-line" key={`intf-product-${i}`}>
                {i < offline_arr.length ?  <div>
                        <a rel="noopener noreferrer" target="_blank" href={baseUrl + offline_products[offline_arr[i]].link}>
                            {intl.formatMessage({id: offline_products[offline_arr[i]].id})}
                        </a>
                    </div>
                    : <div></div>}
                {i < online_arr.length ?  <div>{online_arr[i]}</div> : <div></div>}
            </div>);
            elems.push(html)
        }
        return elems
    }
    showPassWordModal = () => {
        // this.setState( {
        //     passwordModal: true
        // })
        this.props.dispatch({type: 'SIGN_KEY_MODAL_STATUS', payload: {status: true}})
    }
    closePasswordModal = () => {
        this.props.dispatch({type: 'SIGN_KEY_MODAL_STATUS', payload: {status: false}})
    }
    public render() {
        let props = this.props
        let {intl} = this.props
        return (
            <div className="developer">
                <div className="developerMainContent">
                    <div className="section-settings clear">
                        <h3>{intl.formatMessage({id: 'developerInfo'})}</h3>
                        <div className="content">
                            <div className="info">
                                <label>{intl.formatMessage({id: 'merchantName'})}:</label>
                                <span>{props.name}</span>
                            </div>
                            <div className="info">
                                <label>{intl.formatMessage({id: 'merchantNo'})}:</label>
                                <span>{props.merchantNo}</span>
                            </div>
                            <div className="info">
                                <label>PartnerNo:</label>
                                <span>{props.partnerNo}</span>
                            </div>

                            <div className="info">
                                <label>SecretKey:</label>
                                {props.signKey ? props.signKey :
                                    <button onClick={this.showPassWordModal}>{intl.formatMessage({id: 'view'})}</button>}
                            </div>
                        </div>
                    </div>
                    <div className="section-settings clear">
                        <h3>{intl.formatMessage({id: 'storeInfo'})}</h3>
                        <div className="content">
                            <div className="table-style-header">
                                <div>{intl.formatMessage({id: 'storeName'})}</div>
                                <div>{intl.formatMessage({id: 'storeId'})}</div>
                            </div>
                            <div className="storeList table-style-content">
                                {this.props.storeList.map((store, i) => {
                                    return (<div className="store table-style-line" key={store.storeNo}>
                                        <div>{store.storeName}</div>
                                        <div>{store.storeNo}</div>
                                    </div>)
                                })}

                            </div>
                        </div>
                    </div>
                    <div className="section-settings clear">
                        <h3>{intl.formatMessage({id: 'interfaces'})}</h3>
                        <div className="content">
                            <div className="table-style-header">
                                <div>{intl.formatMessage({id: 'offline'})}</div>
                                <div>{intl.formatMessage({id: 'online'})}</div>
                            </div>
                            <div className="interfaces table-style-content">
                                {this._renderProducts()}
                            </div>
                        </div>
                    </div>
                </div>
                <CustomDialog open={this.props.signKeyModal}
                              title={`${intl.formatMessage({id: 'view'})} Secret Key`}
                              showActions={false}
                              content={<PasswordModal handleClose={this.closePasswordModal}/>}
                              handleClose={this.closePasswordModal}/>
            </div>
        );
    }
}

export default injectIntl(connect((state: reducerStoreType) => {
    return state.developer
})(Developer))
